export default __webpack_public_path__ + "static/media/step_03.4e6831e7.svg";